import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_APPLICATION_TYPES,
    applicationTypesReceived,
} from '../actions'



function * fetchApplicationTypes (){
    try{
       const response=  yield call(DCore.get, `/applicants/types`)
        yield put (applicationTypesReceived(response.data))

    }catch(e){
        console.log("some thing went wrong", e)
    }
}



export function * fetchApplicationTypesSaga(){
    yield takeLatest(FETCH_APPLICATION_TYPES,fetchApplicationTypes)
}